import { arrInc } from '../../../fun-js-lib/arr'
import { canvasFonted } from '../../../fun-js-lib/canvas'
import Rect from '../../../fun-js-lib/geometry/Rect'
import { drawDiagonal, fillStyled, fillTextStyled, rectColored, textWidth } from '../../canvasDraw'
import { textCentered, textCram } from '../drawUtils'
import { mainFrameRect } from '../rects'
import { textPadding } from '../sizes'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} linesColor 
 * @param {import('../../constructionLog').LogPage} page 
 */
export function textWeather (context, linesColor, page) {
  let frame = mainFrameRect()
  let x = frame.x + 840 + 190 + 480 + 280 + 40
  let y = frame.y + 250

  fillTextStyled(context, 'Температура', x, y + 70, linesColor)

  arrInc(3).forEach(i => {
    let _x = x
    let _y = y + 165 + i * 80
    fillTextStyled(context, 'У', _x, _y, linesColor)
    _x += textWidth(context, 'У') + textPadding
    let w1 = 90
    fillStyled(context, linesColor, () =>
      context.fillRect(_x, _y, w1, 1)
    )
    let rect1 = Rect.plain({
      x: _x,
      y: _y - 30,
      w: w1,
      h: 30
    })
    textCenteredOrDiagonal(context, page.temperatures[i].temperatureTime, rect1)

    _x += w1 + textPadding
    fillTextStyled(context, 'час', _x, _y, linesColor)
    _x += textWidth(context, 'час') + textPadding
    let w2 = 60
    rectColored(context, _x, _y, w2, 1, linesColor)
    let rect2 = Rect.plain({
      x: _x,
      y: _y - 30,
      w: w2,
      h: 30
    })
    textCenteredOrDiagonal(context, page.temperatures[i].temperatureValue, rect2)

    _x += w2 + textPadding
    fillTextStyled(context, 'C°', _x, _y, linesColor)
  })

  x += 430
  let text2 = 'Време'
  fillTextStyled(context, text2, x, y + 70, linesColor)

  let texts3 = ['(сунчано, облачно, киша)', '(брзина ветра)', '(ниво подземних вода)']
  let values = [
    page.weather,
    page.wind_speed,
    page.water_level]
  texts3.forEach((t, n) => {
    let w = 280
    let _y = y + 166 + n * 80

    rectColored(context, x, _y, w, 1, linesColor)
    canvasFonted(context, '36px Arial', () => {
      let rect = Rect.plain({
        x,
        y: _y - 30,
        w,
        h: 30
      })
      textCenteredOrDiagonal(context, values[n], rect)
    })
    canvasFonted(context, '22px Arial', () => {
      fillStyled(context, linesColor, () => {
        textCentered(context, t, x, _y + 17, w)
      })
    })
  })
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} text 
 * @param {Rect} rect
 */
function textCenteredOrDiagonal (context, text, rect) {
  if (text === '') {
    drawDiagonal(context, rect)
  } else {
    let y = rect.y + rect.h - 1
    if (textWidth(context, text) > rect.w) {
      textCram(context, text, rect.x, y, rect.w)
    } else {
      textCentered(context, text, rect.x, y, rect.w)
    }
  }
}